import React from "react";
import styloImage from "../../assets/images/stylo.webp";
import "./PenLoader.css";

function PenLoader({
  compact = false,
  className = "",
}) {
  return (
    <div
      className={`pen-loader ${compact ? "pen-loader--compact" : "pen-loader--hero"} ${className}`.trim()}
      role="status"
      aria-live="polite"
    >
      <div className="pen-loader__scene">
        <div className="pen-loader__hero" aria-hidden="true">
          <div className="pen-loader__signature-wrap">
            <div className="pen-loader__signature-word-mask">
              <div className="pen-loader__signature-word">Chargement</div>
            </div>
            <svg className="pen-loader__signature-line" width="190" height="44" viewBox="0 0 190 44" fill="none">
              <path
                d="M2 18 C38 18 76 18 104 17 C130 16 148 20 166 19 C176 18 183 15 188 10"
                className="pen-loader__signature-line-path"
              />
            </svg>
            <img src={styloImage} alt="" className="pen-loader__pen" />
          </div>
          <div className="pen-loader__divider">
            <span className="pen-loader__divider-line" />
            <span className="pen-loader__divider-dot" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PenLoader;
